import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Chip,
  GridProps
} from '@mui/material';
import { formatCurrency } from './formatters';

interface FinancialChip {
  label: string;
  value: number;
  color?: 'success' | 'primary' | 'warning' | 'info' | 'error';
  icon?: string;
  tooltip?: string;
}

interface DrillDownFinancialChipsProps {
  chips: FinancialChip[];
  title?: string;
  icon?: string;
  variant?: 'outlined' | 'filled';
  size?: 'small' | 'medium';
  showTitle?: boolean;
  containerProps?: GridProps;
}

const DrillDownFinancialChips: React.FC<DrillDownFinancialChipsProps> = ({
  chips,
  title = "Valores Financeiros",
  icon = "💰",
  variant = "outlined",
  size = "medium",
  showTitle = true,
  containerProps
}) => {
  // Validar se há chips para renderizar
  if (!chips || chips.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12} {...containerProps}>
      {showTitle && (
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1, fontWeight: 600 }}>
          {icon} {title}
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {chips.map((chip, index) => (
          <Chip
            key={index}
            label={`${chip.label}: ${formatCurrency(chip.value)}`}
            color={chip.color || 'primary'}
            variant={variant}
            size={size}
            title={chip.tooltip}
          />
        ))}
      </Box>
    </Grid>
  );
};

export default DrillDownFinancialChips; 